var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgThumbsUpDown(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_13451_571asdsadasdads3)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12.2002 5.99998C12.2002 5.44999 11.7502 4.99999 11.2002 4.99999H6.01519L6.6802 1.82499C6.6952 1.74999 6.70519 1.67 6.70519 1.59C6.70519 1.28 6.5802 0.999997 6.37519 0.794998L5.58019 0L0.640196 4.93999C0.370196 5.20999 0.200195 5.58499 0.200195 5.99998V12.5C0.200195 13.3299 0.870195 14 1.7002 14H8.4502C9.0702 14 9.6052 13.625 9.8302 13.085L12.0952 7.79497C12.1602 7.62498 12.2002 7.44498 12.2002 7.24998V5.99998Z",
    fill: "#6F7494"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.9502 10H22.7002C23.5302 10 24.2002 10.67 24.2002 11.5V18C24.2002 18.415 24.0302 18.79 23.7602 19.06L18.8202 24L18.0252 23.205C17.8202 23 17.6952 22.72 17.6952 22.41C17.6952 22.33 17.7052 22.25 17.7202 22.175L18.3852 19H13.2002C12.6502 19 12.2002 18.55 12.2002 18V16.75C12.2002 16.555 12.2402 16.375 12.3052 16.205L14.5702 10.915C14.7952 10.375 15.3302 10 15.9502 10Z",
    fill: "#6F7494"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_13451_571asdsadasdads3"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white",
    transform: "translate(0.200195)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgThumbsUpDown);
export default __webpack_public_path__ + "static/media/ThumbsUpDown.2ef4dd881972cda06e1aa0cae08c24a1.svg";
export { ForwardRef as ReactComponent };